import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthBootstrapService } from '../services/auth-bootstrap.service';
import { AuthService } from '../../auth/services/auth/auth.service';
import { ENTITY_ROUTES } from '../../entity/constants/entity-routes.constants';

export const superadminGuard: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const authBootstrap = inject(AuthBootstrapService);
  const authService = inject(AuthService);
  const router = inject(Router);

  return authBootstrap.ensureSessionReady().pipe(
    map((session): boolean | UrlTree => {
      if (authBootstrap.isGuest(session)) {
        return router.createUrlTree(['/login']);
      }

      const isSuperadmin =
        session.user?.is_superadmin === true || authService.isSuperadmin();

      return isSuperadmin ? true : router.createUrlTree([ENTITY_ROUTES.root]);
    }),
    catchError(() => of(router.createUrlTree(['/login'])))
  );
};
